import { create } from 'zustand';
import { getLocalStorageValue, SEEDANCE_STORAGE_KEYS } from '../utils/seedanceStorage';

/**
 * Seedance 全局认证状态。
 *
 * 只放跨页面都会依赖的认证/接口配置：
 * - 创作页需要 apiKey 提交生成任务；
 * - 素材库和任务页需要 systemToken + configUserId 访问后台接口；
 * - Layout 需要 connected 展示连接状态。
 *
 * 注意：这里不直接写 localStorage，保存时机仍由业务动作控制，避免输入框每次变化都持久化。
 */
interface SeedanceAuthState {
  /** 火山/首页科技模型调用 Key。 */
  apiKey: string;
  /** 当前 apiKey 是否已通过连接校验。 */
  connected: boolean;
  /** 后台系统访问令牌，用于素材库和任务列表接口。 */
  systemToken: string;
  /** 后台用户 ID，用于 New-Api-User 请求头。 */
  configUserId: string;
  setApiKey: (apiKey: string) => void;
  setConnected: (connected: boolean) => void;
  setSystemToken: (systemToken: string) => void;
  setConfigUserId: (configUserId: string) => void;
  customGroupId: string;
  setCustomGroupId: (customGroupId: string) => void;
}

export const useSeedanceAuthStore = create<SeedanceAuthState>((set) => ({
  apiKey: getLocalStorageValue(SEEDANCE_STORAGE_KEYS.apiKey),
  connected: false,
  systemToken: getLocalStorageValue(SEEDANCE_STORAGE_KEYS.systemToken),
  configUserId: getLocalStorageValue(SEEDANCE_STORAGE_KEYS.configUserId),
  customGroupId: getLocalStorageValue(SEEDANCE_STORAGE_KEYS.customGroupId),
  setApiKey: (apiKey) => set({ apiKey }),
  setConnected: (connected) => set({ connected }),
  setSystemToken: (systemToken) => set({ systemToken }),
  setConfigUserId: (configUserId) => set({ configUserId }),
  setCustomGroupId: (customGroupId) => set({ customGroupId }),
}));
